import { Injectable } from '@angular/core';
import { QueryConfig, QueryEntity } from '@datorama/akita';
import { MessageState, MessageStore } from './message.store';

@Injectable()
@QueryConfig({
  sortBy: 'createdAt',
})
export class MessageQuery extends QueryEntity<MessageState> {
  constructor(protected store: MessageStore) {
    super(store);
  }
}
